/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import { styled } from 'fierry/react.old';

import BorderGroup from 'galax/react/map/hex/border.group';


const getTargetSelectionStroke = ({ geometry }) =>
{
  return geometry.getHex().getExternalSize(0.05);
}


const getTargetSelectionLength = ({ geometry }) =>
{
  return geometry.getHex().getExternalSize(0.075);
}


const getTargetSelectionOffset = ({ geometry }) =>
{
  return geometry.getHex().getExternalWidth(0.075);
}


const Line = styled.line`
  stroke: var(--svg-always-other);

  stroke-linecap: round;
  stroke-width: ${props => getTargetSelectionStroke(props)};
`;


const getLineProps = (props) =>
{
  const length = getTargetSelectionLength(props);
  const offset = getTargetSelectionOffset(props);

  return { x1: offset, y1: 0, x2: offset + length, y2: 0 };
}


const SelectionLine = ({ index, neighbors, targetLocations, borderGeometry, ...props }) =>
{
  const neighbor = borderGeometry.getNeighbor().getLocation()

  const predicate = (target) =>
  {
    return neighbor && target.location.getCoords().toString() === neighbor.getID();
  };

  if (targetLocations.findIndex(predicate) !== -1)
  {
    return null;
  }

  return <Line {...props} {...getLineProps(props)} />;
}


export default (props) =>
(
  <BorderGroup {...props} Component = {SelectionLine} />
)
